import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../api/auth/auth.service';
import { RedirectService } from '../api/auth/redirect.service';

@Injectable({ providedIn: 'root' })
export class WhenNotAuthenticatedGuard  {

  constructor(private authenticationService: AuthService,
              private router: Router,
              private redirectService: RedirectService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.authenticationService.checkAuthentication().then(
      () => {
        this.redirectService.redirectToDefault();
        return false;
      },
      () => {
        return true;
      },
    );
  }
}
